import React, { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/style.css';
import './css/searchBarStyle.css';
import './css/responsive.css';
import Axios from "axios";
import $ from "jquery";
import Shortcuts from "./TopBar";
import MapSearch from "./MapSearch";
import Settings from "./Settings";
import menuIcon2 from "./images/menuicon2.png";

function BottomBar(props) {

    const [queryTop, setQueryTop] = useState('');
    // const [weatherSuggestion, setWeatherSuggestion] = useState([])
    const [stateName, setStateName] = useState(props.stateName)
    const [activeTab, setActiveTab] = useState('')
    const [icon, setIcon] = useState('')
    const [temp, setTemp] = useState('')
    const [city, setCity] = useState('')
    const [showShortcuts, setShowShortcuts] = useState(localStorage.getItem('show_shortcuts') || true)
    const [showWeather, setShowWeather] = useState(true)
    const [isFahrenheit, setIsFahrenheit] = useState(true)
    const [loading, setLoading] = useState(true)
    const [templateSearch, setTemplateSearch] = useState('')

    let displayShortcut = props.displayShortcut
    let setDisplayShortcut = props.setDisplayShortcut
    let suggestionsTop = props.suggestionsTop
    let setSuggestionsTop = props.setSuggestionsTop
    let weatherQuery = props.weatherQuery
    let displayDate = props.displayDate
    let setDisplayDate = props.setDisplayDate
    let displaySetting = props.displaySetting
    let setDisplaySetting = props.setDisplaySetting
    let setMainSuggestions = props.setMainSuggestions
    let closeModal = props.closeModal
    let showImage = props.showImage
    let setShowImage = props.setShowImage
    let setCustomImage = props.setCustomImage

    useEffect(() => {
        let cityName = localStorage.getItem('cityName')
        const timeOut = cityName === null ? 1750 : 50;
        setTimeout(() => {
            let cityName = localStorage.getItem('cityName')
            setCity(cityName)
            let state = localStorage.getItem('stateName')
            setStateName(state)
            getWeather(cityName)
        }, timeOut)
        setLoading(false)
    }, [])
    useEffect(() => {
        getsuggestions('topbar')
    }, [queryTop])

    const templateSearchFunction = () => {
        if (templateSearch !== "") {
            window.open(`https://earthview360.org/links/search.php?${encodeURIComponent(templateSearch)}`, "_blank")
        }
    }

    const getsuggestions = (type) => {
        $.getJSON("https://ff.search.yahoo.com/gossip?output=jsonp&command=" + queryTop + "&callback=?", function (data) {
            if (data.gossip.results.length > 0 && ($('#topbarsearch').val())) {
                $('.search-border1').addClass("expand-search1");
            } else {
                $('.search-border1').removeClass("expand-search1");
            }

            $("#topbarsearch").blur(function () {
                $(".search-border1").removeClass("expand-search1");
            })

            setSuggestionsTop(data.gossip.results)
            var li = $('.pointerCursor');
            var liSelected;
            $('#topbarsearch').keydown(function (e) {
                if (e.which === 40) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        let next = liSelected.next();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                            document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        } else {
                            liSelected = li.eq(0).addClass('active');
                            document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        }
                    } else {
                        liSelected = li.eq(0).addClass('active');
                        document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                    }
                    // liSelected.trigger('click');
                } else if (e.which === 38) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        let next = liSelected.prev();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                            document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        } else {
                            liSelected = li.last().addClass('active');
                            document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        }
                    } else {
                        liSelected = li.last().addClass('active');
                        document.getElementById('topbarsearch').value = (document.getElementById('topbarsearch').value.length === 0 ? '' : liSelected[0].innerText)
                    }
                }
            });
        });
    }
    const searchFromSuggestion = (keyword) => {
        window.open(`https://earthview360.org/extension/public/search?kw=${encodeURIComponent(keyword)}`);
    }

    const getWeather = async (address) => {
        const SECRET_KEY = await "3ea48c53439d343afd46c0268a5ab4e8"
        const URL = await (`https://api.openweathermap.org/data/2.5/weather?q=${address},&APPID=${SECRET_KEY}&units=imperial`)
        Axios.get(URL).then(response => {
            setIcon(response.data.weather[0].icon)
            setTemp(response.data.main.temp)
            setCity(response.data.name)
        }).catch((err) => {
            console.log("err", err)
        })
    }

    const search = () => {
        let keyword1 = document.getElementById('topbarsearch').value
        window.open(`https://earthview360.org/extension/public/search?kw=${encodeURIComponent(keyword1)}`);

    }


    return (
        !loading ? <>
            <div className="head-header">
                <div className="header-main-section d-flex justify-content-between align-items-center">
                    <div className="header-form d-flex align-items-center justify-content-around">
                        <div className="wrapper1">
                            <div className='search-border1'>
                                <div className="search-input1">
                                    <form onSubmit={(e) => {
                                        e.preventDefault()
                                        searchFromSuggestion(document.getElementById('topbarsearch').value)
                                        setSuggestionsTop([])
                                    }}>

                                        <input list="topbar_autosearch" id="topbarsearch"
                                            autoComplete={'off'}
                                            type="search" placeholder="Search" aria-label="Search"
                                            onChange={async (e) => {
                                                await setQueryTop(e.target.value)
                                                await setDisplayShortcut(false)
                                                await setDisplaySetting(false)
                                            }} />
                                        <div className="icon1" onClick={() => {
                                            search()
                                        }}></div>
                                        {suggestionsTop.length && queryTop.length ?
                                            <div id="topbarsearchautocomplete-list1" className="autocomplete-items1">
                                                {suggestionsTop.map((item, i) => {
                                                    return (
                                                        <div className={'pointerCursor'} key={i} onClick={async () => {
                                                            document.getElementById('topbarsearch').value = item.key
                                                            await setQueryTop('')
                                                            await setSuggestionsTop([])
                                                            setDisplayShortcut(false)
                                                            setDisplaySetting(false)
                                                            searchFromSuggestion(item.key)
                                                        }}>
                                                            <span id='autocomplete1-icon'><img src='./smallsearchicon.png' alt='Small search Icon'></img></span>
                                                            <strong style={{
                                                                color: '#5a5a5a',
                                                                fontWeight: '400'
                                                            }}>{queryTop}</strong>
                                                            {item.key.substr(queryTop.length)}
                                                        </div>
                                                    )
                                                })}
                                            </div> :
                                            <div className={'main_search_autocomplete_item1'}>
                                                <strong>{''}</strong>{''}
                                            </div>}
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="header-logo pointerCursorImage">

                            <img src="https://earthview360.org/images/logo.png" alt='Earthview 360 Logo' onClick={() => {
                                setDisplayShortcut(!displayShortcut)
                                setDisplaySetting(false)
                                setSuggestionsTop([])
                            }} />

                        </div>

                    </div>
                    <div className="wether-shorcut d-flex align-items-center">
                        {showWeather ? <Settings
                            stateName={stateName} city={city} icon={icon}
                            temp={temp.toString().length === 0 ? 0 : parseInt(temp)}
                            isFahrenheit={isFahrenheit}
                        /> : null}
                        {showShortcuts ? <div className="header-shortcut" id="headershortcuts">
                            <Button onClick={() => {
                                setDisplayShortcut(!displayShortcut)
                                setDisplaySetting(false)
                                setSuggestionsTop([])
                            }}><span>
                                    <i className="fas fa-bars" /></span> Earth Maps</Button>
                        </div> : null}
                    </div>
                </div>
            </div>
            {displayShortcut ? <Shortcuts /> : null}
            <footer onClick={() => {
                closeModal()
            }}>
                <ul className="footer-links" onClick={() => {
                    closeModal()
                    setDisplaySetting(false)
                    setDisplayShortcut(false)
                    setSuggestionsTop([])
                    setMainSuggestions([])
                }}>
                </ul>
                <div className="config">
                    <button type="submit" onClick={() => {
                        setDisplaySetting(!displaySetting)
                        setDisplayShortcut(false)
                        setSuggestionsTop([])
                    }}>
                        <img src={menuIcon2} className="menu-icon" alt='Menu icon' />
                    </button>
                </div>
                {displaySetting ? <div className="setting" id='footer_ff'>
                    <div className="title-section">Settings</div>
                    <div className="row bottom-section">
                        <div className="col-4">
                            <ul className="text-left list-unstyled left-menu">
                                <li>
                                    <button onClick={() => {
                                        setActiveTab('templates_search')
                                    }} rel="noreferrer" className="">Earth Maps
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => {
                                        setActiveTab('weather')
                                    }} rel="noreferrer" className="">Weather
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => {
                                        setActiveTab('backgrounds')
                                    }} rel="noreferrer" className="">Backgrounds
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => {
                                        setActiveTab('features')
                                    }} rel="noreferrer" className="">Features
                                    </button>
                                </li>
                                <li><a rel="noreferrer" className="" target="_blank"
                                    href="https://earthview360.org/pages/privacy.html">
                                    <button>Privacy Policy</button>
                                </a></li>
                                <li><a rel="noreferrer" className="" target="_blank"
                                    href="https://earthview360.org/pages/eula.html">
                                    <button>EULA</button>
                                </a></li>
                                <li><a rel="noreferrer" className="" target="_blank"
                                    href="https://earthview360.org/pages/dmca.html">
                                    <button>DMCA Policy</button>
                                </a></li>
                                <li><a rel="noreferrer" className="" target="_blank"
                                    href="https://earthview360.org/pages/uninstall.html">
                                    <button>Uninstall</button>
                                </a></li>
                                <li><a rel="noreferrer" className="" target="_blank"
                                    href="https://earthview360.org/pages/contact.html">
                                    <button>Contact Us</button>
                                </a></li>
                            </ul>
                        </div>
                        <div className="col-8" id="menu-right">
                            <div className="shortcuts-modal" id="shortcuts-modal"
                                style={{ display: activeTab === 'templates_search' ? 'block' : 'none' }}>
                                <div className="shortcuts-main-menu">
                                    <div className="wrapper1">
                                        <div className="text-center mb-2 bold">Search Earth Maps</div>
                                        <hr style={{ width: '75%', margin: 'auto' }} />
                                        <div className="search-input2" style={{ marginTop: '15px' }}>
                                            <form id="topbar-form1" onSubmit={(e) => {
                                                e.preventDefault()
                                            }}>
                                                <span>
                                                    <MapSearch />

                                                </span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="weather" style={{ display: activeTab === 'weather' ? 'block' : 'none' }}>
                                <div className="text-center mb-2">Weather Widget</div>
                                <hr style={{ width: '75%', margin: 'auto' }} />
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-7" style={{ textAlign: 'left' }}>
                                        <div className="label">Weather</div>
                                    </div>
                                    <div className="col-5" style={{ textAlign: 'left' }}>
                                        <div>
                                            <label id="wether-switch">
                                                <input type="checkbox" id="weathercheck" checked={showWeather}
                                                    onChange={() => {
                                                        setShowWeather(!showWeather)
                                                    }} />
                                                <span className="slider rounded1" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-7" style={{ textAlign: 'left' }}>
                                        <div className="label">Metric Units</div>
                                    </div>
                                    <div className="col-5" style={{ textAlign: 'left' }}>
                                        <div>
                                            <label id="wether-switch">
                                                <input type="checkbox" id="metricUnits" onChange={() => {
                                                    setIsFahrenheit(!isFahrenheit)
                                                }} />
                                                <span className="slider rounded1" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="backgrounds" style={{ display: activeTab === 'backgrounds' ? 'block' : 'none' }}>
                                <div className="text-center mb-2">Upload Background Image</div>
                                <hr style={{ width: '75%', margin: 'auto' }} />
                                <div className="row">
                                    <div style={{ textAlign: 'center', width: '100%' }}>
                                        <div className="upload-text" style={{ marginTop: '20px' }}><p>
                                            - Max Size 2MB -</p>
                                        </div>
                                        <div className="select-file">
                                            <input accept="image/gif, image/jpeg, image/png" type="file"
                                                onChange={(e) => {
                                                    let file = e.target.files[0]
                                                    if (((file.size) / 1024) / 1024 > 2048) {
                                                        alert('size of the file exceeds')
                                                        return
                                                    }
                                                    const reader = new FileReader();
                                                    reader.addEventListener("load", function () {
                                                        // convert image file to base64 string
                                                        setCustomImage(reader.result)
                                                        localStorage.setItem('online_tools_custom_bg_image__', reader.result)
                                                    }, false);
                                                    reader.readAsDataURL(file);
                                                }}
                                                id="customBG" />
                                            <button className="btn btn-lg">Choose Image</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="features" style={{ display: activeTab === 'features' ? 'block' : 'none' }}>
                                <div className="text-center mb-2">Additional Features</div>
                                <hr style={{ width: '75%', margin: 'auto' }} />
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-7" style={{ textAlign: 'left' }}>
                                        <div className="label">Time &amp; Date</div>
                                    </div>
                                    <div className="col-5" style={{ textAlign: 'left' }}>
                                        <div>
                                            <label id="wether-switch">
                                                <label id="wether-switch">
                                                    <input type="checkbox" id="dateandtime" checked={displayDate}
                                                        onChange={() => {
                                                            setDisplayDate(!displayDate)
                                                            localStorage.setItem('displayDate', displayDate)
                                                        }} />
                                                    <span className="slider rounded1" />
                                                </label>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-7" style={{ textAlign: 'left' }}>
                                        <div className="label">Earth Maps Menu</div>
                                    </div>
                                    <div className="col-5" style={{ textAlign: 'left' }}>
                                        <div>
                                            <label id="wether-switch">
                                                <label id="wether-switch">
                                                    <input type="checkbox" id="shortcutsmenu"
                                                        checked={showShortcuts} onChange={() => {
                                                            setShowShortcuts(!showShortcuts)
                                                            localStorage.setItem("show_shortcuts", showShortcuts)
                                                        }} />
                                                    <span className="slider rounded1" />
                                                </label>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-7" style={{ textAlign: 'left' }}>
                                        <div className="label">Background</div>
                                    </div>
                                    <div className="col-5" style={{ textAlign: 'left' }}>
                                        <div>
                                            <label id="wether-switch">
                                                <input type="checkbox" id="bgcolor" checked={showImage === true}
                                                    onChange={() => {
                                                        setShowImage(!showImage)
                                                        localStorage.setItem("show_image", !showImage)
                                                    }} />
                                                <span className="slider rounded1" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
            </footer>
        </> : null
    );

}

export default BottomBar;